import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_DESCRIPTION, DEVICES } from '../../const';
import AboutThirdMark from '../../assets/about-third-mark.png';
import { useMediaQuery } from '@mui/material';

const Container = styled.div`
  background-color: #fff;
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    padding: 60px 0;
    text-align: center;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding: 100px 0;
    text-align: left;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftHeading = styled.div`
  font-weight: 700;
  color: ${COLOR_ACCENT};
`;

const LeftTitle = styled.div`
  font-weight: 700;
  margin-top: 1rem;
  line-height: 1.5;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.5rem;
  }
`;

const LeftDescription = styled.div`
  margin-top: 2rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const LeftQuestion = styled.div`
  margin-top: 2rem;
  font-weight: 600;
  display: flex;
  border-radius: 20px;
  background: #f2efea;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);

  @media ${DEVICES.mobile} {
    padding: 1.5rem 1.5rem;
    font-size: 14px;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
    padding: 1.5rem 3rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const LeftHighlightMark = styled.div`
  @media ${DEVICES.mobile} {
    min-width: 20px;
  }

  @media ${DEVICES.tablet} {
    min-width: 50px;
  }

  @media ${DEVICES.laptop} {
  }
`;

const LeftHighlightText = styled.div`
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightImg = styled.img`
  width: 100%;
  border-radius: 20px;
  @media ${DEVICES.mobile} {
  }
  
  @media ${DEVICES.tablet} {
    aspect-ratio: 1;
  }

  @media ${DEVICES.large} {
  }
`;

export default function AboutThirdBanner() {

  const overTablet = useMediaQuery(DEVICES.tablet);

  const descriptionTemplate = () => {
    if (overTablet) {
      return <div>
        영어에는 문법, 수학에는 기초 공식, 그리고 모든 운동에는 <br />
        ‘기능성 운동’이 필요합니다. 어린 아이들의 신체 기능을 향상시키는 <br />
        기능성 운동은 모든 스포츠의 기본이 됩니다.
      </div>
    } else {
      return <div>
        영어에는 문법, 수학에는 기초 공식, <br />
        그리고 모든 운동에는 ‘기능성 운동’이 필요합니다. <br />
        어린 아이들의 신체 기능을 향상시키는 <br />
        기능성 운동은 모든 스포츠의 기본이 됩니다. <br />
      </div>
    }
  };

  const highlightTemplate = () => {
    if (overTablet) {
      return <div>
        실패를 두려워하지 않는 마음을 기르고 <br />
        끝까지 도전하여 정당하게 결과를 취하는 끈기와 <br />
        올곧음을 자연스럽게 습득하게 됩니다.
      </div>
    } else {
      return <div>
        실패를 두려워하지 않는 마음을 <br />
        기르고 끝까지 도전하여 정당하게 <br />
        결과를 취하는 끈기와 올곧음을 <br />
        자연스럽게 습득하게 됩니다. <br />
      </div>
    }
  }

  return (
    <Container>
      <Inner>
        <Right>
          <RightImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/third.jpg" />
        </Right>
        <Left>
          <LeftTitle>
            답은 기능성 운동에 <br />
            있었습니다.
          </LeftTitle>
          <LeftDescription>
            {descriptionTemplate()}
          </LeftDescription>
          <LeftQuestion>
            <LeftHighlightMark>
              <img src={AboutThirdMark} width={40} height={40} />
            </LeftHighlightMark>
            <LeftHighlightText>
              {highlightTemplate()}
            </LeftHighlightText>
          </LeftQuestion>
        </Left>
      </Inner>
    </Container>
  )
}
